import React, { Component, Fragment, RefObject } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import {
  Transformer as HTMLTransformerElement
} from 'konva/lib/shapes/Transformer'
import { RootState } from '../../store'
import { produce } from 'immer'
import Card from '../Card'
import LabelProperties from './LabelProperties'
import CloneLabelProperties from './CloneLabelProperties'
import ElementProperties from './ElementProperties/ElementProperties'
import ElementPicker from './ElementPicker'

interface Props {
  transformerRef: RefObject<HTMLTransformerElement>
}

type CombinedProps = Props & ConnectedProps<typeof connector>

class Aside extends Component<CombinedProps> {
  get labelAndElementProperties () {
    return !this.props.cloning && (
      <Fragment>
        <LabelProperties transformerRef={this.props.transformerRef} />
        <ElementPicker />
        <ElementProperties />
      </Fragment>
    )
  }

  get cloneLabelProperties () {
    return this.props.cloning && <CloneLabelProperties />
  }

  render () {
    return (
      <Card
        background="white"
        flat={true}
        className="h-fit min-h-full">
        {this.labelAndElementProperties}
        {this.cloneLabelProperties}
      </Card>
    )
  }
}

function mapStateTopProps (state: RootState, props: Props) {
  const { labelBuilder } = produce(state, draft => draft)
  const { cloning } = labelBuilder
  return { cloning }
}

const mapDispatchToProps = {}

const connector = connect(mapStateTopProps, mapDispatchToProps)
export default connector(Aside)
